import { Box, Heading, Link, SimpleGrid, Text, VStack } from '@chakra-ui/react';
import dayjs from 'dayjs';
import React from 'react';
import NextLink from 'next/link';
import AuthorAvatar from './AuthorAvatar';
import CoverImage from './CoverImage';
// import Date from './PostDate'
import type { Post } from '../../libs/sanity.queries';

export default function HeroPost(props: Pick<Post, 'title' | 'date' | 'coverImage' | 'excerpt' | 'author' | 'slug'>) {
  const { title, coverImage, excerpt, author, date, slug } = props;
  return (
    <section>
      <Box mb={16}>
        <CoverImage slug={slug} title={title} image={coverImage} />
      </Box>
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10} mb={20}>
        <VStack spacing={10} alignItems='start'>
          <Link as={NextLink} href={`/posts/${slug}`}>
            <Heading as='h3' mb={2} size='6xl' fontSize='2xl' fontWeight='bold'>
              {title}
            </Heading>
          </Link>
          {date && (
            <Text color='bg-default-inverted' opacity={0.8} mb={10}>
              {dayjs(date).format('D MMMM, YYYY')}
            </Text>
          )}
        </VStack>
        <VStack spacing={10} alignItems='start'>
          {excerpt && (
            <Text color='bg-default-inverted' fontSize='lg'>
              {excerpt}
            </Text>
          )}
          {author && <AuthorAvatar name={author.name} image={author.image} />}
        </VStack>
      </SimpleGrid>
    </section>
  );
}
